export default __webpack_public_path__ + "static/media/spaceman3.1e48803f.png";